import { useTranslation } from "react-i18next";

import styles from "./GameOver.module.css";

interface Props {
  msg: string;
}

export default function GameOver({ msg }: Props) {
  const { t } = useTranslation();

  function backHandler() {
    window.location.reload();
  }

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>{t("GameOver.title")}</h1>
      {msg && (
        <>
          <div className={styles.message}>{msg}</div>
        </>
      )}
      <div className={styles.thanks}>
        <p>{t("GameOver.thanks")}</p>
        <button className={styles.backButton} onClick={backHandler}>
          {t("GameOver.backButton")}
        </button>
      </div>
    </div>
  );
}
